import { useEffect, useState } from "react";
import Button from "../../Components/Button";
import CardHU from "../../Components/CardHU";
import Footer from "../../Components/Footer";
import { HUForm } from "../../Components/HUForm";
import { ListCardBox } from "../../Components/ListCardBox";
import ModalElement from "../../Components/Modal";
import { useHabUnits } from "../../Providers/HabUnit";
import { useUser } from "../../Providers/User";
import { HUContainer, Container } from "./styles";

const UnitHabits = () => {
  const { AdmHUList, listHUs } = useHabUnits();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { admAuth } = useUser();

  const handleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  useEffect(() => {
    listHUs();
  }, []);

  useEffect(() => {}, [AdmHUList]);

  return (
    <Container>
      <HUContainer>
        <ListCardBox>
          {AdmHUList?.map((el) => (
            <CardHU key={el.id} data={el} isInPage={false} />
          ))}
        </ListCardBox>
        {admAuth && (
          <Button onClick={handleModal} className="addButton">
            Novo
          </Button>
        )}
        <ModalElement isOpen={modalIsOpen} closeModal={handleModal}>
          <HUForm closeModal={handleModal} />
        </ModalElement>
      </HUContainer>
      <Footer />
    </Container>
  );
};
export default UnitHabits;
